export interface IReversRoll {
  amount: number;
  calcPeriod: number;
  docDate: string;
  invoiceId: number;
  typeOperationId: number;
}

export interface IInvoice {
  amount: number;
  amountTax: number;
  calcPeriod: string;
  invoiceDate: string; // format: 20180531000000
  invoiceId: number;
  invoiceNumb: number;
  invoicesData?: Array<IInvoiceTariff>;
  isBase: boolean;
}

export interface IInvoiceTariff {
  serviceAmount: number;
  serviceCount: number;
  tariffName: string;
}

export enum OrganisationType {
  Legal = '0',
  Individual = '1',
}
